import { Box, Text } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { CustomTwoColumnsList } from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/CustomTwoColumnList'
import { Expensable } from 'modules/expenses/types/Expensable'

import CustomWidgetHeaderButton from './CustomWidgetHeaderButton'

interface AdditionalInformationWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
  showDescription?: boolean
  showInternalReference?: boolean
}

const AdditionalInformationWidget = ({
  expensable,
  editable,
  onEdit,
  showDescription,
  showInternalReference,
}: AdditionalInformationWidgetProps) => {
  if (!showDescription && !showInternalReference) return null

  const description = expensable?.description ?? ''
  const internalReference = expensable?.internalReference ?? ''

  const notAssignedBlock = (
    <Text.Normal size="200" color="grey800">
      {i18n.t('expenses_v2.confirmation_screen.not_assigned_placeholder')}
    </Text.Normal>
  )

  const list = [
    ...(showDescription
      ? [
          {
            title: i18n.t(
              'expenses_v2.confirmation_screen.expense.additional_information_block.description'
            ),
            info: description,
            customInfoBlock: description ? undefined : notAssignedBlock,
          },
        ]
      : []),
    ...(showInternalReference
      ? [
          {
            title: i18n.t(
              'expenses_v2.confirmation_screen.expense.additional_information_block.internal_reference'
            ),
            info: internalReference,
            customInfoBlock: internalReference ? undefined : notAssignedBlock,
          },
        ]
      : []),
  ]

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t(
            'expenses_v2.confirmation_screen.expense.additional_information_block.title'
          ),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default AdditionalInformationWidget
